export default __webpack_public_path__ + "static/media/pa1.d2878841.png";